<div *ngIf="isOpen" class="fixed inset-0 z-30 flex items-center justify-center">
  <!-- Backdrop -->
  <div
    *ngIf="showBackdrop"
    class="fixed inset-0 bg-black transition-opacity"
    [style.opacity]="backdropOpacity"
    (click)="close()"
  ></div>

  <!-- Modal -->
  <div
    class="max-w-[50%] relative bg-white rounded-lg shadow dark:bg-gray-700"
    [ngClass]="modalClasses"
    [class.cursor-move]="isDraggable"
    [attr.draggable]="isDraggable"
    @modalAnimation
  >
    <!-- Modal header -->
    <div
      [ngClass]="{ 'border-b': showDivisors }"
      class="flex items-start justify-between p-4 rounded-t dark:border-gray-600"
    >
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white" *ngIf="title">
        {{ title }}
      </h3>
      <button
        *ngIf="showCloseButton"
        type="button"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
        (click)="close()"
      >
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>

    <!-- Modal content -->
    <div class="p-6">
      <ng-template [ngTemplateOutlet]="modalBodyTemplate"></ng-template>
    </div>

    <!-- Modal footer -->
    <ng-container *ngIf="modalFooterTemplate">
      <div
        [ngClass]="{ 'border-t': showDivisors }"
        class="flex items-center p-6 space-x-2 border-gray-200 rounded-b dark:border-gray-600"
      >
        <ng-template [ngTemplateOutlet]="modalFooterTemplate"></ng-template>
      </div>
    </ng-container>
  </div>
</div>
